/* eslint-disable */
export class Utils {
    static bitReverse(value) {
        return (Utils.reverseBits[value & 15] << 12
            | Utils.reverseBits[(value >> 4) & 15] << 8
            | Utils.reverseBits[(value >> 8) & 15] << 4
            | Utils.reverseBits[value >> 12]);
    }
    static bitConverterToInt32(value, index) {
        return value[index] | value[index + 1] << 8 | value[index + 2] << 16 | value[index + 3] << 24;
    }
    static bitConverterToInt16(value, index) {
        return value[index] | value[index + 1] << 8;
    }
    static bitConverterToUInt32(value) {
        let uint = new Uint32Array(1);
        uint[0] = value;
        return uint[0];
    }
    static bitConverterToUInt16(value, index) {
        let uint = new Uint16Array(1);
        uint[0] = (value[index] | value[index + 1] << 8);
        return uint[0];
    }
    static bitConverterUintToInt32(value) {
        let uint = new Int32Array(1);
        uint[0] = value;
        return uint[0];
    }
    static bitConverterInt32ToUint(value) {
        let uint = new Uint32Array(1);
        uint[0] = value;
        return uint[0];
    }
    static bitConverterInt32ToInt16(value) {
        let uint = new Int16Array(1);
        uint[0] = value;
        return uint[0];
    }
    static byteToString(value) {
        let str = '';
        for (let i = 0; i < value.length; i++) {
            str += String.fromCharCode(value[i]);
        }
        return str;
    }
    static byteIntToString(value) {
        let str = '';
        for (let i = 0; i < value.length; i++) {
            str += String.fromCharCode(value[i]);
        }
        return str;
    }
    static arrayCopy(source, sourceIndex, destination, destinationIndex, dataToCopy) {
        let temp = new Uint8Array(source.buffer, sourceIndex);
        let data = temp.subarray(0, dataToCopy);
        destination.set(data, destinationIndex);
    }
    static mergeArray(arrayOne, arrayTwo) {
        let mergedArray = new Uint8Array(arrayOne.length + arrayTwo.length);
        mergedArray.set(arrayOne);
        mergedArray.set(arrayTwo, arrayOne.length);
        return mergedArray;
    }
    /**
     * @private
     */
    static encodedString(input) {
        let keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let chr1;
        let chr2;
        let chr3;
        let encode1;
        let encode2;
        let encode3;
        let encode4;
        let count = 0;
        let resultIndex = 0;
        /*let dataUrlPrefix: string = 'data:';*/
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');
        let totalLength = input.length * 3 / 4;
        if (input.charAt(input.length - 1) === keyStr.charAt(64)) {
            totalLength--;
        }
        if (input.charAt(input.length - 2) === keyStr.charAt(64)) {
            totalLength--;
        }
        if (totalLength % 1 !== 0) {
            // totalLength is not an integer, the length does not match a valid
            // base64 content. That can happen if:
            // - the input is not a base64 content
            // - the input is *almost* a base64 content, with a extra chars at the
            // beginning or at the end
            // - the input uses a base64 variant (base64url for example)
            throw new Error('Invalid base64 input, bad content length.');
        }
        let output = new Uint8Array(totalLength | 0);
        while (count < input.length) {
            encode1 = keyStr.indexOf(input.charAt(count++));
            encode2 = keyStr.indexOf(input.charAt(count++));
            encode3 = keyStr.indexOf(input.charAt(count++));
            encode4 = keyStr.indexOf(input.charAt(count++));
            chr1 = (encode1 << 2) | (encode2 >> 4);
            chr2 = ((encode2 & 15) << 4) | (encode3 >> 2);
            chr3 = ((encode3 & 3) << 6) | encode4;
            output[resultIndex++] = chr1;
            if (encode3 !== 64) {
                output[resultIndex++] = chr2;
            }
            if (encode4 !== 64) {
                output[resultIndex++] = chr3;
            }
        }
        return output;
    }
}
Utils.reverseBits = [0, 8, 4, 12, 2, 10, 6, 14, 1, 9, 5, 13, 3, 11, 7, 15];
Utils.huffCodeLengthOrders = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
/* eslint-enable */ 
